import * as React from 'react'
import {observer} from 'mobx-react'
import {EpikQueryParam} from '@raisenow/epik'
import {useStores} from '../../../../lib/MobXProvider'
import {DynamicSlotName} from '../../../../lib/DynamicSlotName'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {DynamicSlot} from '../../../dynamic/DynamicSlot'
import {IconClose} from '../../../ui/Icons'

///////////////////////////////////////////////////////////////////////////////

export const SubscriptionPaymentMethodUpdated = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const closeBlock = () => {
    api.epik.updateCurrentUrl({
      params: {
        [EpikQueryParam.VIEW]: undefined,
      },
    })
  }

  return (
    <div className="subscription-payment-method-updated">
      <div className="header">
        <div className="title">
          <h2 className="text">
            {api.trans('blocks.subscription_payment_method_updated.subtitle')}
          </h2>
        </div>
        <button type="button" className="close" onClick={closeBlock}>
          <div className="icon">
            <IconClose />
          </div>
        </button>
      </div>

      <DynamicSlot
        name={DynamicSlotName.SUBSCRIPTION_PAYMENT_METHOD_UPDATED_START}
      />

      <div
        className="main"
        dangerouslySetInnerHTML={{
          __html: api.trans(
            'blocks.subscription_payment_method_updated.text_html',
          ),
        }}
      />

      <DynamicSlot
        name={DynamicSlotName.SUBSCRIPTION_PAYMENT_METHOD_UPDATED_END}
      />
    </div>
  )
})
